import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { MdSearch } from 'react-icons/md';
import { useDispatch } from 'react-redux';

import { useDebounce } from 'use-debounce';

import { clearSearchFilterRequest } from '~/store/modules/tasks/actions';

import { ContainerInputSearch } from './styles';

export interface SearchInputImperativeProps {
  handleReset: () => void;
}

interface Props {
  placeholder: string;
  getSearch: (search: string) => void;
  // eslint-disable-next-line react/require-default-props
  valueAlreadyExists?: string;
}

type InputProps = JSX.IntrinsicElements['input'] & Props;

const InputSearchDebounce = forwardRef(
  (
    { placeholder, getSearch, valueAlreadyExists, ...rest }: InputProps,
    ref,
  ) => {
    const [search, setSearch] = useState<string>('');
    const [searchDebounce] = useDebounce(search, 800);

    const dispatch = useDispatch();

    const onChange = (e: any) => {
      setSearch(e.target.value);
      if (e.target.value !== valueAlreadyExists) {
        dispatch(clearSearchFilterRequest());
      }
    };

    useImperativeHandle(ref, () => ({
      handleReset: () => {
        setSearch('');
        dispatch(clearSearchFilterRequest());
      },
    }));

    useEffect(() => {
      if (valueAlreadyExists) {
        setSearch(valueAlreadyExists);
      }
      getSearch(search);

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchDebounce]);

    return (
      <ContainerInputSearch>
        <MdSearch size={28} />
        <input
          aria-label="search-input"
          id="search-input"
          type="text"
          placeholder={placeholder}
          onChange={onChange}
          value={search}
          {...rest}
        />
      </ContainerInputSearch>
    );
  },
);
export default InputSearchDebounce;
